var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.23001H21.17",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87842 12.62V22.5H20.7985V12.62",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1683 15.28H9.51831V21.92H14.1683V15.28Z",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4183 2V8.44C15.4183 9.69 14.7983 10.87 13.7283 11.51C12.8083 12.07 11.5983 12.39 10.3383 11.62C9.30826 10.99 8.72827 9.82 8.72827 8.61V2",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5183 2L7.62828 9.93C7.30828 11.13 6.39823 12.11 5.19823 12.46C4.16823 12.76 2.9183 12.76 1.8983 11.68C1.0683 10.8 0.818281 9.52 1.12828 8.35L2.86827 2",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7983 2L22.2983 8.23C22.6083 9.44 22.2983 10.74 21.4283 11.63C20.6783 12.4 19.5883 13.01 18.1783 12.58C17.0183 12.23 16.1683 11.23 15.8683 10.06L15.4883 2",
    stroke: "#EF5226",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.9984b3d71abd881af5b2097175cff0b1.svg";
export { ForwardRef as ReactComponent };